export default __webpack_public_path__ + "static/media/tflspinner.a038bcf2.gif";